import * as React from "react";
import EditorialBase from "../../EditorialBase";
import { ContentFlexComponent, ContentProps } from "components/flexComponents/Content/typings";
import IconSectionEditorial from "./IconSectionEditorial";
import CitiTripleDipSectionEditorial from "./Citi/CititripledipSectionEditorial";
import CitiDesktopStickyBar from "./Citi/CitiDesktopStickybar";
import CitifaqSectionEditorial from "./Citi/CitiFaqSectionEditorial";
import CitiRewardsWithoutCompSectionEditorial from "./Citi/CitiRewardsWithoutCompSectionEditorial";
import CitiCalculatorSectionEditorial from "./Citi/CitiCalculatorSectionEditorial";

export class Grid3 extends EditorialBase {
  /* istanbul ignore next */
  constructor(editorial: ContentFlexComponent) {
    super(editorial);
  }

  public generate(props: ContentProps) {
    const { model } = props.flexComponent;
    const stickyBarText = "Sticky_bar";
    const RwcSection = "Citi_Rwc_Section";
    const iconSectionTitle = "icon_section";
    const calculatorSectionTitle = "Citi_Calculator_Section";

    return (
      <>
        {model.title.includes("triple_dip_section") && (
          <CitiTripleDipSectionEditorial
            flexComponent={props.flexComponent}
            l10n={props.l10n}
            context={props.context}
          />
        )}

        {model.title.includes(stickyBarText) && (
          <CitiDesktopStickyBar flexComponent={props.flexComponent} l10n={props.l10n} context={props.context} />
        )}

        {model.title.includes("Citi_Faq_Section") && (
          <CitifaqSectionEditorial flexComponent={props.flexComponent} l10n={props.l10n} context={props.context} />
        )}

        {model.title.includes(RwcSection) && (
          <CitiRewardsWithoutCompSectionEditorial
            flexComponent={props.flexComponent}
            l10n={props.l10n}
            context={props.context}
          />
        )}

        {model.title.includes(iconSectionTitle) && (
          <IconSectionEditorial flexComponent={props.flexComponent} l10n={props.l10n} context={props.context} />
        )}

        {model.title.includes(calculatorSectionTitle) && (
          <CitiCalculatorSectionEditorial
            flexComponent={props.flexComponent}
            l10n={props.l10n}
            context={props.context}
          />
        )}
      </>
    );
  }
}

export default Grid3;
